import { render, staticRenderFns } from "./Credits.vue?vue&type=template&id=26f56610&scoped=true"
import script from "./Credits.vue?vue&type=script&lang=js"
export * from "./Credits.vue?vue&type=script&lang=js"
import style0 from "./Credits.vue?vue&type=style&index=0&id=26f56610&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f56610",
  null
  
)

export default component.exports